import { PageHero } from '@/components/PageHero';
import { Chapters } from '@/components/Chapters';
import { CtaBanner } from '@/components/CtaBanner';
import { Reveal } from '@/components/Reveal';
import { useSeo } from '@/components/Seo';
import { STATIC_IT } from '@/data/staticIt';
import { STATIC_EN } from '@/data/staticEn';
import { useLang } from '@/i18n/LangContext';
import { Compass, Eye, Scale, Users, HandHeart, RefreshCw } from 'lucide-react';

const ICONS = { Compass, Eye, Scale, Users, HandHeart, RefreshCw };

export default function ChiSiamo() {
  const { lang, t } = useLang();
  const c = lang === 'en' ? STATIC_EN.chiSiamo : STATIC_IT.chiSiamo;
  useSeo(c.seo);

  return (
    <div data-testid="chi-siamo-page">
      <PageHero
        eyebrow={c.eyebrow}
        title={c.title}
        summary={c.summary}
        image="/assets/area-aziende.webp"
        imageAlt={c.title}
        breadcrumbs={[{ label: t('breadcrumbHome'), href: '/' }, { label: c.eyebrow }]}
      />

      <section className="mx-auto max-w-site px-5 md:px-8 py-16 md:py-24">
        <Reveal className="max-w-2xl mb-14">
          <p className="text-xs uppercase tracking-[0.25em] font-semibold text-primary mb-4">{c.role.eyebrow}</p>
          <h2 className="font-heading text-4xl md:text-5xl font-bold tracking-tight leading-tight">
            {c.role.title}
          </h2>
        </Reveal>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-border border border-border">
          {c.role.items.map((item, i) => {
            const Icon = ICONS[item.icon];
            return (
              <Reveal key={item.title} delay={i * 0.05}>
                <div className="bg-white p-6 md:p-8 h-full hover:bg-brand-pale/40 transition-colors duration-300">
                  <span className="inline-flex bg-brand-pale p-3 rounded-lg mb-4">
                    <Icon className="h-6 w-6 text-primary" />
                  </span>
                  <h3 className="font-heading text-lg md:text-xl font-bold tracking-tight mb-3">{item.title}</h3>
                  <p className="text-sm md:text-base leading-relaxed text-foreground/70">{item.text}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </section>

      <Chapters items={c.method.items} eyebrow={c.method.eyebrow} title={c.method.title} />

      <div className="mx-auto max-w-site px-5 md:px-8">
        <CtaBanner
          title={c.cta.title}
          text={c.cta.text}
          label={c.cta.label}
        />
      </div>
    </div>
  );
}
